/**
 * Functionality to store column visibilities of bootstrap tables in local storage.
 * Works on bootstrap tables where data-global-id attribute is set and data-show-columns="true".
 */
$(document).ready(function() {
  $('.table[data-show-columns="true"][data-global-id]').each(function(index, element) {
    const table = $(element);
    const storageKey = 'column-settings-' + table.data('global-id');

    table.on('column-switch.bs.table', function() {
      const visibleColumns = table.bootstrapTable('getVisibleColumns').map((it) => it.field);
      const hiddenColumns = table.bootstrapTable('getHiddenColumns').map((it) => it.field);
      let visibility = visibleColumns.reduce((result, column) => ({...result, [column]: true}), {});
      visibility = hiddenColumns.reduce((result, column) => ({...result, [column]: false}), visibility);
      window.localStorage.setItem(storageKey, JSON.stringify(visibility));
    });

    const visibility = JSON.parse(window.localStorage.getItem(storageKey));
    if (visibility) {
      const visibleColumns = [];
      const hiddenColumns = [];
      for (const [column, isVisible] of Object.entries(visibility)) {
        isVisible ? visibleColumns.push(column) : hiddenColumns.push(column);
      }
      table.bootstrapTable('showColumn', visibleColumns);
      table.bootstrapTable('hideColumn', hiddenColumns);
    }
  });
});
